import { Component, OnInit } from '@angular/core'
import {
  LOGIN_URL,
  STUDENT_SERVICES_EMAIL,
  STUDENT_SERVICES_PHONE
} from '../../'

import { UIExpirationMessageService } from '../../'

@Component({
  selector: 'mp-no-syllabus',
  templateUrl: './no-syllabus.html',
  styleUrls: ['./no-syllabus.scss']
})
export class NoSyllabusComponent implements OnInit {
  public homeURL = LOGIN_URL
  public studentServicesEmail = STUDENT_SERVICES_EMAIL
  public studentServicesPhone = STUDENT_SERVICES_PHONE

  constructor(
    private _expirationMessageService: UIExpirationMessageService
  ) {}

  public ngOnInit() {
    this._expirationMessageService.broadcastExpiringProducts().subscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/no-syllabus/no-syllabus.component.ts